export default "/_next/static/images/magic-line-sparkle-right-56432331251a3d7567d733c20a7f82b8.svg";